module.exports = __webpack_public_path__ + "static/media/icon_event_shot_on_goal.acfe998b.svg";